import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import InvoicesTable, { InvoicesTableSearchFilters } from 'components/invoices/InvoicesTable';
import { useSearchParams } from 'react-router-dom';
import { AthleteRetrieve } from 'types';

import AthleteInvoiceHeader from './components/AthleteInvoiceHeader';

const Invoice = ({
  athlete,
  openTabsDrawer,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  openTabsDrawer: () => void;
  permission?: boolean;
}): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const invoiceIdFromUrl = searchParams.get('invoiceId');

  const initialSearchFiltersValue: InvoicesTableSearchFilters = {
    athlete: athlete.athleteId,
    search: '',
    dueDateRange: [null, null],
    status: [],
    autoPay: null,
    paymentMethods: [],
  };

  const [searchFilters, setSearchFilters] = useState<InvoicesTableSearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<InvoicesTableSearchFilters>(searchFilters, 250);

  const handleClearInvoiceIdFromUrl = (): void => {
    searchParams.delete('invoiceId');
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <>
      <AthleteInvoiceHeader
        searchFilters={searchFilters}
        openTabsDrawer={openTabsDrawer}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
      />
      <InvoicesTable
        searchFilters={debouncedSearchFilters}
        removeColumns={[
          'athlete',
          'pretaxTotal',
          'tax',
          'updatedAt',
          'paymentDate',
          'autoPay',
          'paymentMethod',
        ]}
        permission={permission}
        margin={0}
        bgc={'gray'}
        initialInvoiceId={invoiceIdFromUrl || undefined}
        onDrawerClose={handleClearInvoiceIdFromUrl}
      />
    </>
  );
};

export default Invoice;
